"use strict";

var TextUtils = function TextUtils(app, textField, config) {

    if (!textField) {
        throw new Error("No text field provided");
    }

    config = config || {};

    // Config
    this.app = app;
    this.zoomLevel = app && app.zoomLevel ? app.zoomLevel : 1;
    this.textField = textField;
    this.fakeTextAreaId = config['fakeTextAreaId'] || "fontCalcTextArea";
    this.root = config['root'] || document.body; // Element to append the fake textarea to
    this.maxFontSize = config['maxFontSize'] || TextUtils.DEFAULTS['maxFontSize']; // Max font size allowed (in px)
    this.minFontSize = config['minFontSize'] || TextUtils.DEFAULTS['minFontSize']; // Min font size allowed (in px)
    this.widthOffset = config['widthOffset'] || 0; // Offset to apply to the calculate text field width (in px)
    this.heightOffset = config['heightOffset'] || 0; // Offset to apply to the calculate text field height (in px)

    // Computed on the fly
    this.lineHeight = null;
    this.availableLineWidth = null;
    this.availableLineHeight = null;
};

TextUtils.DEFAULTS = {
    'maxFontSize': 14,
    'minFontSize': 8
};
TextUtils.CHAR_SIZE_MAP = {};
TextUtils.LETTER_SPACING_MAP = {};
TextUtils.NEW_LINE_CHAR_CODE = 10;
TextUtils.SPACE_CHAR_CODE = 32;

TextUtils.prototype.constructor = TextUtils;

//  ----  HELPERS  ----------------------------------------

TextUtils.prototype.createFakeTextArea = function (realTextArea) {

    var s = window.getComputedStyle(this.textField);
    var span = document.createElement('span');

    for (var i = 0; i < s.length; i++) {
        span.style[s[i]] = s[s[i]];
    }

    span.id = this.fakeTextAreaId;
    span.style["float"] = 'left';
    span.style.width = 'auto';
    span.style.visibility = 'hidden';
    span.style.padding = '0';
    span.style.border = '0 none';
    span.style.letterSpacing = '0';

    this.root.appendChild(span);

    return span;
};

TextUtils.prototype.calcCharSize = function (charCode, fontSize) {
    var fakeTextArea = document.getElementById(this.fakeTextAreaId);
    if (!fakeTextArea) {
        fakeTextArea = this.createFakeTextArea(this.textarea);
    }
    fakeTextArea.style['font-size'] = fontSize + 'px';
    if (this.app && this.app.zoomLevel && this.app.zoomLevel !== this.zoomLevel) {
        this.zoomLevel = this.app.zoomLevel;
        fakeTextArea.style['zoom'] = 100.0 * this.zoomLevel + '%';
    }
    fakeTextArea.innerHTML = charCode === 32 ? '&nbsp;' : String.fromCharCode(charCode);
    var rect = fakeTextArea.getBoundingClientRect();
    return rect.right - rect.left;
};

TextUtils.prototype.calcLetterSpacing = function (fontSize) {

    // FIXME: Make this work - should extract 0.05em from the page instead of hard-coding it

    // var letterSpacing = this.textField.style.letterSpacing;
    // if (!letterSpacing) {
    //     return 0;
    // }

    // var fakeTextArea = document.getElementById(this.fakeTextAreaId);
    // if (!fakeTextArea) {
    //     fakeTextArea = this.createFakeTextArea(this.textarea);
    // }

    // fakeTextArea.style.fontSize = fontSize + 'px';
    // fakeTextArea.style.letterSpacing = '0px';
    // fakeTextArea.innerHTML = "A";

    // var widthWithoutLS = parseFloat(window.getComputedStyle(fakeTextArea).width, 10);
    // fakeTextArea.style.letterSpacing = letterSpacing;
    // var widthWithLS = parseFloat(window.getComputedStyle(fakeTextArea).width, 10);
    // fakeTextArea.style.letterSpacing = '0px';

    // return (widthWithLS - widthWithoutLS);

    return 0.05 * fontSize;
};

TextUtils.prototype.queryCharSize = function (charCode, fontSize) {

    if (!TextUtils.CHAR_SIZE_MAP[charCode] || !TextUtils.CHAR_SIZE_MAP[charCode][fontSize] || !TextUtils.CHAR_SIZE_MAP[charCode][fontSize][this.zoomLevel]) {
        // Calculate
        TextUtils.CHAR_SIZE_MAP[charCode] = TextUtils.CHAR_SIZE_MAP[charCode] || {};
        TextUtils.CHAR_SIZE_MAP[charCode][fontSize] = TextUtils.CHAR_SIZE_MAP[charCode][fontSize] || {};
        TextUtils.CHAR_SIZE_MAP[charCode][fontSize][this.zoomLevel] = this.calcCharSize(charCode, fontSize);
    }

    return TextUtils.CHAR_SIZE_MAP[charCode][fontSize][this.zoomLevel] + this.queryLetterSpacing(fontSize);
};

TextUtils.prototype.queryLetterSpacing = function (fontSize) {
    if (!TextUtils.LETTER_SPACING_MAP[fontSize]) {
        TextUtils.LETTER_SPACING_MAP[fontSize] = this.calcLetterSpacing(fontSize);
    }
    return TextUtils.LETTER_SPACING_MAP[fontSize];
};

TextUtils.prototype.getAvailableWidth = function (styles) {
    if (this.availableLineWidth === null) {
        if (!styles) {
            styles = window.getComputedStyle(this.textField);
        }
        var originalWidth = parseFloat(styles['width'], 10);
        var includePadding = styles['box-sizing'] != 'content-box';
        var paddingLeft = includePadding && styles['padding-left'] ? parseFloat(styles['padding-left'], 10) : 0;
        var paddingRight = includePadding && styles['padding-right'] ? parseFloat(styles['padding-right'], 10) : 0;
        this.availableLineWidth = originalWidth + this.widthOffset - paddingLeft - paddingRight;
    }
    return this.availableLineWidth;
};

TextUtils.prototype.getAvailableHeight = function () {
    if (this.availableLineHeight === null) {
        var styles = window.getComputedStyle(this.textField);
        var originalHeight = parseFloat(styles['height'], 10);
        var includePadding = styles['box-sizing'] != 'content-box';
        var paddingTop = includePadding && styles['padding-top'] ? parseFloat(styles['padding-top'], 10) : 0;
        var paddingBottom = includePadding && styles['padding-bottom'] ? parseFloat(styles['padding-bottom'], 10) : 0;
        this.availableLineHeight = originalHeight - paddingTop - paddingBottom + this.heightOffset;
    }
    return this.availableLineHeight;
};

TextUtils.prototype.getLineHeight = function () {
    if (this.lineHeight === null) {
        var styles = window.getComputedStyle(this.textField);
        this.lineHeight = parseFloat(styles['line-height'], 10);
        if (isNaN(this.lineHeight)) {
            // Default to the font size then
            this.lineHeight = parseFloat(styles['font-size'], 10);
        }
    }
    return this.lineHeight;
};

TextUtils.prototype.isMultiLine = function () {
    // NOTE: Default minimum height is 16px for text fields
    return this.getAvailableHeight() > 1.5 * 16;
};

//  ----  PUBLIC API  -------------------------------------

TextUtils.prototype.getLines = function (forcedFontSize) {

    var text = this.textField.value;
    var styles = window.getComputedStyle(this.textField);
    var fontSize = forcedFontSize || parseFloat(styles['font-size'], 10);
    var availableLineWidth = this.getAvailableWidth(styles);
    var lineWidth = 0;
    var lines = [''];
    var lineNum = 0;
    var word = '';
    var wordWidth = 0;
    var charWidth = 0;

    for (var i = 0; i < text.length; i++) {

        var c = text.charCodeAt(i);

        if (c === TextUtils.NEW_LINE_CHAR_CODE) {

            // Add the current word
            if (wordWidth > 0) {
                lines[lineNum] += word;
                word = '';
                wordWidth = 0;
            }

            // Add the new line
            lineWidth = 0;
            lineNum++;
            lines.push('');
        } else if (c === TextUtils.SPACE_CHAR_CODE) {

            // Add the current word since we've reach its end
            if (lineWidth + wordWidth > availableLineWidth) {
                // Add the word to the next line since it can't fit on the current one
                lineWidth = wordWidth;
                lineNum++;
                lines.push(word);
            } else {
                // Add the word to the current line
                lineWidth += wordWidth;
                lines[lineNum] += word;
            }

            word = '';
            wordWidth = 0;

            // Add the space character
            charWidth = this.queryCharSize(c, fontSize);
            if (lineWidth + charWidth > availableLineWidth) {

                // NOTE: Only create a new line when it ends with a space.
                // Multiline text fields have this strange behavior where all spaces get squashed
                // until you type a non-space character.

                lineWidth = 0;
                lineNum++;
                lines.push('');

                // Skip over to the next non-space character
                for (var _i = i; _i < text.length; _i++) {
                    if (text.charCodeAt(_i) !== TextUtils.SPACE_CHAR_CODE) {
                        i = _i - 1;
                        break;
                    }
                }
            } else {
                // Add it to the current line
                lineWidth += charWidth;
                lines[lineNum] += text[i];
            }
        } else {

            charWidth = this.queryCharSize(c, fontSize);

            if (wordWidth + charWidth >= availableLineWidth) {
                // The current word is too long to fit on a single line so cut it
                lines[lineNum] += word;
                lines.push('');
                lineNum++;
                word = '';
                wordWidth = 0;
            }

            // Keep on building the current word
            word += text[i];
            wordWidth += charWidth;

            if (i === text.length - 1) {
                // Add the last word
                if (lineWidth + wordWidth > availableLineWidth) {
                    // Add the last word to the next since it can't fit on the current one
                    lines.push(word);
                } else {
                    // Add the word to the current line
                    lines[lineNum] += word;
                }
            }
        }
    }

    return lines;
};

TextUtils.prototype.getBestFitFontSize = function (isPrefilled) {

    if (!this.textField.value) {
        return this.maxFontSize;
    }

    var fontSize;
    // hack to make prefilled text (editable merge fields) smaller and fit in the textbox.
    // gives wiggle room since we can't accurately determine character count on backend to throw errors. -DW
    // TODO: resolve inconsistency of character estimation logic between frontend and backend (and remove this hack)
    var minSize = this.minFontSize - (isPrefilled ? 2 : 0); // 6 = smallest reasonably visible text

    if (this.isMultiLine()) {

        var availableNumLines = Math.round(this.getAvailableHeight() / this.getLineHeight());
        var selectedFontSize;
        var numLines;

        for (fontSize = this.maxFontSize; fontSize >= minSize; fontSize--) {
            numLines = this.getLines(fontSize).length;
            if (numLines <= availableNumLines) {
                return fontSize;
            }
        }
    } else {

        var availableLineWidth = this.getAvailableWidth();
        for (fontSize = this.maxFontSize; fontSize >= minSize; fontSize--) {
            var l = this.getTextLength(this.textField.value, fontSize);
            if (l <= availableLineWidth) {
                return fontSize;
            }
        }
    }
};

TextUtils.prototype.getTextLength = function (text, fontSize) {
    var l = 0;
    for (var i = 0; i < text.length; i++) {
        l += this.queryCharSize(text.charCodeAt(i), fontSize);
    }
    return l;
};

TextUtils.prototype.reset = function () {
    TextUtils.CHAR_SIZE_MAP = {};
    var el = document.getElementById(this.fakeTextAreaId);
    if (el) {
        document.body.removeChild(el);
    }
};

// A band aid for now while we transition away from these globals
window.TextUtils = TextUtils;

if (typeof module !== 'undefined') {
    module.exports = TextUtils;
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/textutils.js
 ** module id = 8
 ** module chunks = 0
 **/